<template lang="pug">
  .layout
    y-dialog(v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card(flat)
        template(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-col(align="center")
              v-progress-circular.ma-auto(:width="3" :size="30" color="info500" indeterminate)
              div.s1.primary--text.text-center.mt-6 {{ $t('arranging_shipment') }}
              div.p2.primary--text.text-center.mt-1 {{ $t('please_do_not_refresh') }}

        //- ARRANGED SHIPMENT
        template(v-else-if="arrangedShipment")
          v-card-text.px-0(ref="container")
            div.h6.primary500--text.pa-4 {{ arrangedShippings.length }} {{ $t('of') }} {{ yezzaShippings.length }} {{ $t('arrangements_successful') }}
            div.mt-6(align="center")
              v-img(:src="require('@/assets/images/bg_arrange_successful.png')" eager contain max-height="100")
            div.d-flex.align-center.pa-4
              template(v-if="selectedShippingType === 'courier'")
                template(v-if="arrangedShippings.length > 0")
                  div.p2.basic700--text {{ arrangedShippings.length }} {{ $t('air_waybills_generated') }}
                  v-spacer
                  v-btn(v-if="!isCourier" color="info500" @click="downloadBulkAwb(arrangedShippings)" outlined x-small height="24" :style="{'background-color':$vuetify.theme.themes[$theme].infoT08}")
                    eva-icon(name="copy-outline" width="10" height="10" :fill="$vuetify.theme.themes[$theme].info500" style="margin-botton: -1px")
                    div.button-AA-tiny.info500--text {{ $t('download_all') }}
              template(v-else)
                div.p2.basic700--text {{ $t('copy_and_share_tracking') }}
                
            //- COURIER
            template(v-if="selectedShippingType === 'courier'")
              template(v-for="arrangedShipping in DateArrangedShippings")

                //- DROP-OFF COURIER
                template(v-if="arrangedShipping.shippings.filter(f => f.meta_data && f.meta_data.service_type === 'dropoff').length > 0")
                  div.px-4.py-3(style="background-color: var(--v-basic600T16)")
                    div.d-flex.align-center
                      eva-icon(name="calendar-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="18" height="18" style="margin-bottom: -6px")
                      div.s2.basic700--text.ml-1 {{ $t('drop_off') }} | {{ arrangedShipping.date | humanizeDateLong }}
                  template(v-for="shipping in arrangedShipping.shippings.filter(f => f.meta_data && f.meta_data.service_type === 'dropoff')")
                    div.pa-4
                      div.d-flex.align-center
                        div(style="width: 72px" align="center")
                          v-img(:src="shipping.meta_data.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
                        div.pl-2
                          div.c1.basic600--text {{ `#${shipping.order_no}` }}
                          div.p2.basic700--text.mt-1 {{ shipping.meta_data.receiver_name }}
                        v-spacer
                        div(align="right")
                          div.c1.basic600--text {{ shipping.meta_data.tracking_no }}
                          div.p2.basic700--text.mt-1 {{ shipping.meta_data.receiver_address.state }}
                      v-divider.basic300.my-3
                      div.d-flex.align-center.justify-space-around
                        v-btn.button-Aa-small.px-0(text color="transparent" small @click="clickDownloadAWB(shipping.meta_data.awb_link)")
                          eva-icon.mb-n1(name="download-outline" width="16" height="16" :fill="$vuetify.theme.themes[$theme].basic700")
                          div.basic700--text.ml-2 {{ $t('download') }}
                        v-btn.button-Aa-small.px-0(text color="transparent" small @click="shareToWA(shipping.meta_data.tracking_no, shipping.meta_data.receiver_address.phone)")
                          v-icon(color="basic700" size="16") mdi-whatsapp
                          div.basic700--text.ml-2 {{ $t('share') }}
                        v-btn.button-Aa-small.px-0(text color="transparent" small @click="copyTrackingNo" v-clipboard:copy="shipping.meta_data.tracking_no")
                          eva-icon.mb-n1(name="copy-outline" width="16" height="16" :fill="$vuetify.theme.themes[$theme].basic700")
                          div.basic700--text.ml-2 {{ $t('copy') }}
                    v-divider.basic400

                //- PICK UP COURIER
                template(v-if="arrangedShipping.shippings.filter(f => f.meta_data && f.meta_data.service_type === 'pickup').length > 0")
                  div.px-4.py-3(style="background-color: var(--v-basic600T16)")
                    div.d-flex.align-center
                      eva-icon(name="car-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="18" height="18" style="margin-bottom: -6px")
                      div.s2.basic700--text.ml-1 {{ $t('pick_up') }} | {{ arrangedShipping.date | humanizeDateLong }}
                  template(v-for="shipping in arrangedShipping.shippings.filter(f => f.meta_data && f.meta_data.service_type === 'pickup')")
                    div.pa-4
                      div.d-flex.align-center
                        div(style="width: 72px" align="center")
                          v-img(:src="shipping.meta_data.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
                        div.pl-2
                          div.c1.basic600--text {{ `#${shipping.order_no}` }}
                          div.p2.basic700--text.mt-1 {{ shipping.meta_data.receiver_name }}
                        v-spacer
                        div(align="right")
                          div.c1.basic600--text {{ shipping.meta_data.tracking_no }}
                          div.p2.basic700--text.mt-1 {{ shipping.meta_data.receiver_address.state }}
                      v-divider.basic300.my-3
                      div.d-flex.align-center.justify-space-around
                        v-btn.button-Aa-small.px-0(text color="transparent" small @click="clickDownloadAWB(shipping.meta_data.awb_link)")
                          eva-icon.mb-n1(name="download-outline" width="16" height="16" :fill="$vuetify.theme.themes[$theme].basic700")
                          div.basic700--text.ml-2 {{ $t('download') }}
                        v-btn.button-Aa-small.px-0(text color="transparent" small @click="shareToWA(shipping.meta_data.tracking_no, shipping.meta_data.receiver_address.phone)")
                          v-icon(color="basic700" size="16") mdi-whatsapp
                          div.basic700--text.ml-2 {{ $t('share') }}
                        v-btn.button-Aa-small.px-0(text color="transparent" small @click="copyTrackingNo" v-clipboard:copy="shipping.meta_data.tracking_no")
                          eva-icon.mb-n1(name="copy-outline" width="16" height="16" :fill="$vuetify.theme.themes[$theme].basic700")
                          div.basic700--text.ml-2 {{ $t('copy') }}
                    v-divider.basic400

              //- COURIER ARRANGED & REF ID
              div.d-flex.align-center.pa-3(v-if="arrangedShippings.length > 0")
                div.c1.basic600--text {{ $t('arranged') }} {{ displayArrangeOnDate(arrangedShippings[0].submitted_on) }}
                v-spacer
                div.c1.basic600--text {{ $t('ref_id') }}: {{ arrangedShippings[0].ref_id }}

            //- LOCAL DELIVERY
            template(v-if="selectedShippingType === 'local-delivery'")
              template(v-for="arrangedShipping in DateArrangedShippings")
                div.px-4.py-3(style="background-color: var(--v-basic600T16)")
                  div.d-flex.align-center
                    eva-icon(name="clock-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="18" height="18" style="margin-bottom: -6px")
                    div.s2.basic700--text.ml-1 {{ arrangedShipping.date | humanizeDateLong }}
                template(v-for="shipping in arrangedShipping.shippings.filter(f => f.meta_data && f.meta_data.service_type === 'pickup')")
                  div.pa-4
                    div.d-flex.align-center
                      div(style="width: 72px" align="center")
                        v-img(:src="shipping.meta_data.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
                      div.pl-2
                        div.c1.basic600--text {{ `#${shipping.order_no}` }}
                        div.p2.basic700--text.mt-1 {{ shipping.meta_data.receiver_name }}
                      v-spacer
                      div(align="right")
                        div.d-flex.align-center.mt-3
                          v-icon(v-if="shipping.meta_data.service_type === 'car'" size="14" color="basic600") mdi-car-side
                          v-icon(v-else size="14" color="basic600") mdi-moped
                          div.c1.basic600--text.ml-2 {{ shipping.meta_data.service_type }}
                        div.p2.basic700--text.mt-1 {{ shipping.meta_data.receiver_address.address_1 }}{{ shipping.meta_data.receiver_address.address_2 ? `, ${shipping.meta_data.receiver_address.address_2}` : '' }}
                    v-divider.basic300.my-3
                    div.d-flex.align-center.justify-space-around(v-if="shipping.meta_data.tracking_no")
                      v-btn.button-Aa-small.px-0(text color="transparent" small @click="clickOpenTracking(shipping.meta_data.tracking_no)")
                        eva-icon.mb-n1(name="map-outline" width="16" height="16" :fill="$vuetify.theme.themes[$theme].info500")
                        div.info500--text.ml-2 Track
                      v-btn.button-Aa-small.px-0(text color="transparent" small @click="shareTrackingLinkToWA(shipping.meta_data.shipping_name, shipping.meta_data.tracking_no, shipping.meta_data.receiver_address.phone)")
                        v-icon(color="info500" size="16") mdi-whatsapp
                        div.info500--text.ml-2 {{ $t('share') }}
                      v-btn.button-Aa-small.px-0(text color="transparent" small @click="copyTrackingLink" v-clipboard:copy="shipping.meta_data.tracking_no")
                        eva-icon.mb-n1(name="copy-outline" width="16" height="16" :fill="$vuetify.theme.themes[$theme].info500")
                        div.info500--text.ml-2 {{ $t('copy') }}
                    template(v-else)
                      div.c1.basic600--text {{ $t('tracking_data_not_ready') }}
                  v-divider.basic400

              //- LOCAL DELIVERY ARRANGED & REF ID
              div.d-flex.align-center.pa-3(v-if="arrangedShippings.length > 0")
                div.c1.basic600--text {{ $t('arranged') }} {{ displayArrangeOnDate(arrangedShippings[0].submitted_on) }}
                v-spacer
                div.c1.basic600--text {{ $t('ref_id') }}: {{ arrangedShippings[0].ref_id }}

            //-  UNSUCCESSFUL ORDERS
            template(v-if="failedArrangedShippings.length > 0")
              div.d-flex.align-center.pa-4.mt-4
                div.s1.danger500--text {{ $t('unsuccessful_orders') }}
                v-spacer
                v-btn(x-small height="24" color="primary" @click="retryArrange(failedArrangedShippings)")
                  div.white--text.button-AA-tiny {{ $t('retry_arrange') }}
              template(v-for="failed in failedArrangedShippings")
                div.pa-4(style="background-color: var(--v-dangerT08);")
                  div.d-flex.align-center
                    div(style="width: 72px" align="center")
                      v-img(:src="failed.meta_data.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
                    div.pl-2
                      div.c1.basic600--text {{ `#${failed.order_no}` }}
                      div.p2.basic700--text.mt-1 {{ failed.meta_data.receiver_name }}
                    v-spacer
                    div(align="right")
                      div.c1.danger500--text(v-if="failed.ext_remark && failed.ext_remark.includes('send_code')") {{ $t('invalid_postcode') }}
                      div.c1.danger500--text(v-else-if="failed.ext_remark && failed.ext_remark.includes('delivery')") {{ $t('out_of_delivery_service') }}
                      div.c1.danger500--text(v-else) {{ $t('unexpected_internal_error') }}
                      div.p2.basic700--text.mt-1 {{ failed.meta_data.receiver_address.state }}
                v-divider.danger100

          //- DONE BUTTON
          v-divider.basic300
          v-card-actions.px-4
            v-spacer
            v-btn.button-AA-medium(color="info500" depressed dark height="40" @click="finishArranging")
              div.mx-2.text-uppercase {{ $t('done') }}

            //- div.mt-6
              iframe(:src="typeFormRateUrl" :width="containerWidth" height="500px" frameborder="0")

        template(v-else-if="arrangingRider")
          v-card.pa-4(flat)
            v-card-title.pa-0
              v-btn(text icon small @click="closeDialog")
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary700" width="22" height="22")
            v-card-text.d-flex.justify-center.align-center(style="height:80vh")
              div.mt-6(align="center")
                v-progress-circular.mb-10(:width="6" :size="45" color="info500" indeterminate)
                div.s1.mb-2 {{ $t('finding_you_a_rider') }}
                div.p2.mb-10 {{ $t('hold_tight') }}
                v-btn.mb-10(small outlined :style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`" @click="openOngoingDialog")
                  .button-AA-small.primary500--text {{ $t('view_all_ongoing_orders') }}

        template(v-else)
          v-card-title.pa-4
            v-btn(text icon small @click="closeDialog" height)
              eva-icon.mt-1(name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
            div.ml-3.h6.primary500--text {{ $t('bulk_arrange_shipment') }}

          template(v-if="yezzaShippingError")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-col(align="center")
                div.s1.danger500--text.text-center {{ $t('unable_to_complete_request') }}

          template(v-else)
            v-card-text.px-0.pt-0.pb-6
              v-window(v-model="step" touchless)

                //- SELECT SHIPPING TYPE
                v-window-item(:value="0")
                  div.pa-4
                    div.p1.basic700--text {{ $t('select_fulfilment_method') }}
                    div.mt-6(style="border:1px solid var(--v-basic400); border-radius: 4px;")
                      div.pa-4
                        div(@click="selectShippingType('courier')")
                          div.d-flex.align-center
                            div.s2.primary--text {{ $t('courier') }}
                            v-spacer
                            eva-icon.mb-n2(name="chevron-right-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].primary")
                          div.c1.basic600--text {{ $t('courier_examples') }}
                      v-divider.basic400
                      div.pa-4
                        div(@click="selectShippingType('local-delivery')")
                          div.d-flex.align-center
                            div.s2.primary--text {{ $t('local_delivery') }}
                            v-spacer
                            eva-icon.mb-n2(name="chevron-right-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].primary")
                          div.c1.basic600--text {{ $t('local_delivery_examples') }}

                //- SELECT FULFILMENT
                v-window-item(:value="1")
                  div.pa-4
                    div.pa-4(style="border:1px solid var(--v-basic400); border-radius: 4px;")
                      div.s1.basic700--text.mb-2 Select {{ selectedShippingType === 'courier' ? 'courier' : 'delivery'}} service for the following manual rate(s):
                      div.d-flex.ml-2(v-for="zonerate in manualZoneRates")
                        v-avatar(color="basic700" size="5" style="margin-top: 6px;")
                        div.ml-2
                          div.p2.basic700--text {{ $t('zone') }}: {{ zonerate.zone }}
                          div.p2.basic700--text {{ $t('rate') }}: {{ zonerate.rate }}

                    bulk-select-courier.mt-6(v-if="selectedShippingType === 'courier'" :parentRates.sync="rates" :parentSelectedFulfilment.sync="selectedFulfilment")
                    bulk-select-local-delivery.mt-6(v-if="selectedShippingType === 'local-delivery'" :parentRates.sync="rates" :parentSelectedFulfilment.sync="selectedFulfilment")

                    template(v-if="showPreferredService")
                      y-checkbox.mt-5(v-model="preferredService" :color="$vuetify.theme.themes[$theme].info500")
                        template(v-slot:label)
                          div.c1.primary--text {{ $t('save_as_preferred_service') }}
                
                //- LIST BULK SHIPPING
                v-window-item(:value="2")
                  credit-alert.mx-4(:credit="creditBalance" :title="$t('arrange_shipment')" :showTitle="true")

                  div.px-4.mb-4 {{ $t('click_on_individual') }}

                  template(v-if="leadYezzaShippings.length > 0")

                    //- COURIER
                    template(v-if="this.selectedShippingType === 'courier'")
                      template(v-for="leadYezzaShipping in leadYezzaShippings")

                        //- ERROR COURIER
                        template(v-if="leadYezzaShipping.leads.filter(f => !f.yezzashipping.fulfilment || !f.yezzashipping.weight).length > 0")
                          template(v-for="lead in leadYezzaShipping.leads.filter(f => !f.yezzashipping.fulfilment || !f.yezzashipping.weight)")
                            div.pa-4(v-if="selectedFulfilment" style="background-color: var(--v-dangerT08);")
                              div.d-flex.align-center
                                eva-icon.mr-2(name="alert-triangle-outline" :fill="$vuetify.theme.themes[$theme].danger500" width="18" height="18" style="margin-bottom: -5px")
                                div.c2.danger500--text(v-if="!lead.yezzashipping.fulfilment") {{ $t('selected_courier_unavailable') }}
                                div.c2.danger500--text(v-if="!lead.yezzashipping.weight") {{ $t('product_weight_missing') }}
                                v-spacer
                                div(align="right")
                                  a.button-Aa-small.my-auto.danger500--text(@click.stop="clickEditErrorOrder(lead)") {{ $t('edit') }}
                              div.d-flex.mt-3
                                div(style="width: 72px" align="center")
                                  v-img(:src="selectedFulfilment.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
                                div.pl-2
                                  div.c1.basic600--text # {{ lead.rid }}
                                  div.p2.basic700--text.mt-1 {{ lead.name }}
                                  div.p2.basic600--text.mt-1 {{ lead.shipping_address.state }}
                                v-spacer
                                div(align="right")
                                  div.c1.basic600--text(v-if="lead.yezzashipping.weight") {{ lead.yezzashipping.weight }} kg
                                  div.p2.basic700--text.mt-1(v-if="lead.yezzashipping.fee") {{ lead.yezzashipping.fee | displayPrice }}
                            v-divider.basic400

                        //- AVAILABLE DROP-OFF COURIER
                        template(v-if="leadYezzaShipping.leads.filter(f => f.yezzashipping.fulfilment && f.yezzashipping.fulfilment.meta_data.service_type === 'dropoff').length > 0")
                          div.px-4.py-3(style="background-color: var(--v-basic600T16)")
                            div.d-flex.align-center
                              eva-icon(name="calendar-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="18" height="18" style="margin-bottom: -6px")
                              template(v-if="leadYezzaShipping.date")
                                div.s2.basic700--text.ml-1 {{ $t('drop_off') }} | {{ leadYezzaShipping.date | humanizeDateLong }}
                              template(v-else)
                                div.s2.basic700--text.ml-1 {{ $t('drop_off') }} |
                                div.s2.danger500--text.ml-1 {{ $t('please_select_delivery_date') }}
                              v-spacer
                              a.button-Aa-small.my-auto.info500--text(@click="clickEditDateGroup(leadYezzaShipping.leads.filter(f => f.yezzashipping.fulfilment && f.yezzashipping.fulfilment.meta_data.service_type === 'dropoff'))") Edit
                          template(v-for="lead in leadYezzaShipping.leads.filter(f => f.yezzashipping.fulfilment && f.yezzashipping.fulfilment.meta_data.service_type === 'dropoff')")
                            div.d-flex.pa-4(@click="clickEditIndividualOrder(lead)")
                              div(style="width: 72px" align="center")
                                v-img(:src="lead.yezzashipping.fulfilment.meta_data.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
                              div.pl-2
                                div.c1.basic600--text # {{ lead.rid }}
                                div.p2.basic700--text.mt-1 {{ lead.name }}
                                div.p2.basic600--text.mt-1 {{ lead.shipping_address.state }}
                              v-spacer
                              div(align="right")
                                div.c1.basic600--text {{ lead.yezzashipping.weight }} kg
                                div.p2.basic700--text.mt-1 {{ lead.yezzashipping.fee | displayPrice }}
                            v-divider.basic400

                        //- AVAILABLE PICK UP COURIER
                        template(v-if="leadYezzaShipping.leads.filter(f => f.yezzashipping.fulfilment && f.yezzashipping.fulfilment.meta_data.service_type === 'pickup').length > 0")
                          div.px-4.py-3(style="background-color: var(--v-basic600T16)")
                            div.d-flex.align-center
                              eva-icon(name="calendar-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="18" height="18" style="margin-bottom: -6px")
                              template(v-if="leadYezzaShipping.date")
                                div.s2.basic700--text.ml-1 {{ $t('pick_up') }} | {{ leadYezzaShipping.date | humanizeDateLong }}
                              template(v-else)
                                div.s2.basic700--text.ml-1 {{ $t('pick_up') }} |
                                div.s2.danger500--text.ml-1 {{ $t('please_select_delivery_date') }}
                              v-spacer
                              a.button-Aa-small.my-auto.info500--text(@click="clickEditDateGroup(leadYezzaShipping.leads.filter(f => f.yezzashipping.fulfilment && f.yezzashipping.fulfilment.meta_data.service_type === 'pickup'))") {{ $t('edit') }}
                          template(v-for="lead in leadYezzaShipping.leads.filter(f => f.yezzashipping.fulfilment && f.yezzashipping.fulfilment.meta_data.service_type === 'pickup')")
                            div.d-flex.pa-4(@click="clickEditIndividualOrder(lead)")
                              div(style="width: 72px" align="center")
                                v-img(:src="lead.yezzashipping.fulfilment.meta_data.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
                              div.pl-2
                                div.c1.basic600--text # {{ lead.rid }}
                                div.p2.basic700--text.mt-1 {{ lead.name }}
                                div.p2.basic600--text.mt-1 {{ lead.shipping_address.state }}
                              v-spacer
                              div(align="right")
                                div.c1.basic600--text {{ lead.yezzashipping.weight }} kg
                                div.p2.basic700--text.mt-1 {{ lead.yezzashipping.fee | displayPrice }}
                            v-divider.basic400

                    //- LOCAL DELIVERY
                    template(v-if="this.selectedShippingType === 'local-delivery'")
                      template(v-for="leadYezzaShipping in leadYezzaShippings")
                        
                        //- ERROR LOCAL DELIVERY
                        template(v-if="leadYezzaShipping.leads.filter(f => !f.yezzashipping.fulfilment || !f.yezzashipping.weight).length > 0")
                          template(v-for="lead in leadYezzaShipping.leads.filter(f => !f.yezzashipping.fulfilment || !f.yezzashipping.weight)")
                            div.pa-4(v-if="selectedFulfilment" style="background-color: var(--v-dangerT08);")
                              div.d-flex.align-center
                                eva-icon.mr-2(name="alert-triangle-outline" :fill="$vuetify.theme.themes[$theme].danger500" width="18" height="18" style="margin-bottom: -5px")
                                div.c2.danger500--text(v-if="!lead.yezzashipping.fulfilment") {{ $t('selected_delivery_unavailable') }}
                                div.c2.danger500--text(v-if="!lead.yezzashipping.weight") {{ $t('product_weight_missing') }}
                                v-spacer
                                div(align="right")
                                  a.button-Aa-small.my-auto.danger500--text(@click.stop="clickEditErrorOrder(lead)") {{ $t('edit') }}
                              div.d-flex.mt-3
                                div(style="width: 72px" align="center")
                                  v-img(:src="selectedFulfilment.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
                                  div.d-flex.align-center.mt-3
                                    v-icon(v-if="selectedFulfilment.service_type === 'car'" size="14" color="basic600") mdi-car-side
                                    v-icon(v-else size="14" color="basic600") mdi-moped
                                    div.c1.basic600--text.ml-2 {{ selectedFulfilment.service_type }}
                                div.pl-2
                                  div.c1.basic600--text # {{ lead.rid }}
                                  div.p2.basic700--text.mt-1 {{ lead.name }}
                                  div.p2.basic600--text.mt-1 {{ lead.shipping_address.state }}
                                v-spacer
                                div(align="right")
                                  div.c1.basic600--text(v-if="lead.yezzashipping.weight") {{ lead.yezzashipping.weight }} kg
                                  div.p2.basic700--text.mt-1(v-if="lead.yezzashipping.fee") {{ lead.yezzashipping.fee | displayPrice }}
                            v-divider.basic400

                        //- AVAILABLE LOCAL DELIVERY
                        template(v-if="leadYezzaShipping.leads.filter(f => f.yezzashipping.fulfilment && f.yezzashipping.weight).length > 0")
                          div.px-4.py-3(style="background-color: var(--v-basic600T16)")
                            div.d-flex.align-center
                              eva-icon(name="clock-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="18" height="18" style="margin-bottom: -6px")
                              div.s2.basic700--text.ml-1(v-if="leadYezzaShipping.date") {{ leadYezzaShipping.date | humanizeDateLong }}
                              div.s2.basic700--text.ml-1(v-else) {{ getAsapDate() }}
                              v-spacer
                              a.button-Aa-small.my-auto.info500--text(@click="clickEditDateTimeGroup(leadYezzaShipping.leads.filter(f => f.yezzashipping.fulfilment && f.yezzashipping.weight))") {{ $t('edit') }}
                          template(v-for="lead in leadYezzaShipping.leads.filter(f => f.yezzashipping.fulfilment && f.yezzashipping.weight)")
                            div.d-flex.pa-4(@click="clickEditIndividualOrder(lead)")
                              div(style="width: 72px" align="center")
                                v-img(:src="lead.yezzashipping.fulfilment.meta_data.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
                                div.d-flex.align-center.mt-3
                                  v-icon(v-if="lead.yezzashipping.fulfilment.meta_data.service_type === 'car'" size="14" color="basic600") mdi-car-side
                                  v-icon(v-else size="14" color="basic600") mdi-moped
                                  div.c1.basic600--text.ml-2 {{ lead.yezzashipping.fulfilment.meta_data.service_type }}
                              div.pl-2
                                div.c1.basic600--text # {{ lead.rid }}
                                div.p2.basic700--text.mt-1 {{ lead.name }}
                                div.p2.basic600--text.mt-1 {{ lead.shipping_address.state }}
                              v-spacer
                              div(align="right")
                                div.c1.basic600--text {{ lead.yezzashipping.weight }} kg
                                div.p2.basic700--text.mt-1 {{ lead.yezzashipping.fee | displayPrice }}
                            v-divider.basic400
                  
                  div.p2.basic600--text.mt-5.text-center {{ $t('having_issues') }}&nbsp;
                    span.s2.basic600--text.clickable(style="text-decoration: underline;" @click="openTypeFormDialog = true") {{ $t('tell_us_about_it') }}

            v-card-actions.px-4(v-if="step !== 0")
              div(style="width: 100%")
                div.mb-4(v-if="step === 2")
                  div.d-flex.align-center
                    div.h6.primary--text {{ $t('total') }}
                    v-spacer
                    div.h6.primary--text {{ totalFee | displayPrice }}
                  div.c1.basic600--text.mt-2(v-if="selectedShippingType === 'local-delivery'") {{ $t('this_is_not_multistop') }} 
                div.d-flex.align-center
                  v-spacer
                  v-btn(v-if="rates.length === 0" color="transparent" text @click="closeDialog")
                    .button-Aa-medium.primary400--text {{ $t('cancel') }}
                  v-btn(v-else color="transparent" text @click="step--")
                    .button-Aa-medium.primary400--text {{ $t('back') }}
                  v-btn.button-AA-medium(v-if="step === 1" color="info500" depressed height="40" @click="proceedBulkShipping" :loading="isLoading" :dark="Boolean(selectedFulfilment)" :disabled="!selectedFulfilment")
                    div.mx-2(:class="{ 'basic100--text': selectedFulfilment }") {{ $t('proceed_to_review') }}
                  v-btn.button-AA-medium(v-if="step === 2" color="info500" depressed height="40" @click="payNow" :loading="isLoading" :dark="!disabledPaynow" :disabled="disabledPaynow")
                    div.mx-2(:class="{ 'basic100--text': !disabledPaynow }") {{ $t('pay_now') }}
        
    .modal
      edit-individual-order(v-if="editIndividualOrderDialog" :open.sync="editIndividualOrderDialog" :parentYezzaShipping.sync="yezzaShippings[ysIndex]" :lead="selectedOrder" :selectedShippingType="selectedShippingType" @remove="removeOrder($event)" @close="selectedOrder = null; ysIndex = null")
      edit-error-order(v-if="editErrorDialog" :open.sync="editErrorDialog" :parentYezzaShipping.sync="yezzaShippings[ysIndex]" :lead="selectedOrder" :selectedShippingType="selectedShippingType" @remove="removeOrder($event)" @close="selectedOrder = null; ysIndex = null" @updated="handleUpdateAddress")
      edit-date-group(v-if="editDateGroupDialog" :open.sync="editDateGroupDialog" :parentYezzaShippings.sync="ysDateGroup" @update="updateEditGroup($event)")
      edit-date-time-group(v-if="editDateTimeGroupDialog" :open.sync="editDateTimeGroupDialog" :parentYezzaShippings.sync="ysDateTimeGroup" @update="updateEditGroup($event)")
      //- edit-postcode(v-if="editRecipientPostcodeDialog" :open.sync="editRecipientPostcodeDialog" :parentYezzaShipping.sync="yezzaShipping" :lead="lead" @updated="handleUpdateAddress")
      //- tracking-view(v-if="openTrackingViewDialog" :open.sync="openTrackingViewDialog" :link="trackingViewLink")
      type-form-view(v-if="openTypeFormDialog" :open.sync="openTypeFormDialog" :link="typeFormUrl")
</template>

<script>
import { DateTime } from 'luxon'
import { mapState, mapGetters, mapActions } from 'vuex'
import BulkSelectCourier from '@/components/dialogs/yezzashipping/BulkSelectCourier.vue'
import BulkSelectLocalDelivery from '@/components/dialogs/yezzashipping/BulkSelectLocalDelivery.vue'
import EditDateGroup from '@/components/dialogs/yezzashipping/EditDateGroup.vue'
import EditDateTimeGroup from '@/components/dialogs/yezzashipping/EditDateTimeGroup.vue'
import EditIndividualOrder from '@/components/dialogs/yezzashipping/EditIndividualOrder.vue'
import EditErrorOrder from '@/components/dialogs/yezzashipping/EditErrorOrder.vue'
// NOTE: Not in use due to issue with unresponsive button in iframe
// import TrackingView from '@/components/dialogs/yezzashipping/TrackingView.vue'
import CreditAlert from '@/components/yezzabook/dialogs/CreditAlert.vue'
import EditPostcode from '@/components/dialogs/yezzashipping/EditPostcode.vue'
import TypeFormView from '@/components/dialogs/TypeFormView.vue'

export default {
  name: 'BulkArrangeShipment',
  components: { CreditAlert, BulkSelectCourier, BulkSelectLocalDelivery, EditDateTimeGroup, EditDateGroup, EditIndividualOrder, EditErrorOrder, EditPostcode, TypeFormView },
  props: ['open', 'parentLeads'],
  data: () => ({
    isFetching: false,
    isFetchingRates: [false, false],
    isLoading: false,
    editWeightDialog: false,
    editShippingDialog: false,
    editDateTimeGroupDialog: false,
    editDateGroupDialog: false,
    editIndividualOrderDialog: false,
    openTrackingViewDialog: false,
    editRecipientPostcodeDialog: false,
    openTypeFormDialog: false,
    editErrorDialog: false,
    showPreferredService: false,
    yezzaShippingError: false,
    arrangedShipment: false,
    preferredService: false,
    hastPostcodeError: false,
    isReady: false,
    selectedShippingType: null,
    selectedFulfilment: null,
    selectedOrder: null,
    ysIndex: null,
    ysDateGroup: null,
    ysDateTimeGroup: null,
    trackingViewLink: null,
    arrangedShippings: [],
    failedArrangedShippings: [],
    step: 0,
    rates: [],
    yezzaShippings: [],
    arrangingRider: false,
    toOngoingDialogCountdown: null
  }),
  computed: {
    ...mapState('riders', {
      statusCheckIntervalTime: state => state.intervalTime
    }),
    ...mapGetters({
      company: 'getCompany',
      groupedOngoingData: 'riders/getGroupedOngoingData'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    containerWidth() {
      if (this.isReady && this.$refs.container) {
        return this.$refs.container.clientWidth - 18
      }
      return 540
    },
    leads: {
      get() {
        return this.parentLeads
      },
      set(newValue) {
        this.$emit('update:parentLeads', newValue)
      }
    },
    leadYezzaShippings() {
      if (this.yezzaShippings.length > 0) {
        let leadyezzashippings = []
        this.leads.forEach(o => {
          let data = {
            pid: o.pid,
            rid: o.rid,
            name: o.name,
            shipping: o.shipping,
            shipping_address: o.shipping_address,
            yezzashipping: this.yezzaShippings.filter(f => f.shipping === o.shipping.id)[0]
          }
          if (o.postcode_error) {
            data['postcode_error'] = true
          }
          if (o.area_error) {
            data['area_error'] = true
          }
          leadyezzashippings.push(data)
        })
        let dates = leadyezzashippings.map(m => (m.yezzashipping.delivery_at ? m.yezzashipping.delivery_at.substr(0, 10) : m.yezzashipping.delivery_at))
        let uniqueDates = [...new Set(dates)]
        return uniqueDates.map(m => {
          return { date: m, leads: leadyezzashippings.filter(f => (f.yezzashipping.delivery_at ? f.yezzashipping.delivery_at.substr(0, 10) == m : f.yezzashipping.delivery_at == m)) }
        })
      }
      return []
    },
    DateArrangedShippings() {
      if (this.arrangedShippings.length > 0) {
        let dates = this.arrangedShippings.map(m => m.meta_data.sending_date.substr(0, 10))
        let uniqueDates = [...new Set(dates)]
        return uniqueDates.map(m => {
          return { date: m, shippings: this.arrangedShippings.filter(f => f.meta_data.sending_date.substr(0, 10) == m) }
        })
      }
      return []
    },
    manualZoneRates() {
      let manualrates = []
      let zonerate = []
      let final = []
      this.leads.forEach(o => {
        if (o.shipping.shipping_method === 'manual') {
          manualrates.push(o.shipping.selected_option)
          zonerate.push({ zone: o.shipping.zone_name, rate: o.shipping.selected_option })
        }
      })
      let uniqueRates = [...new Set(manualrates)]
      uniqueRates.forEach(o => {
        final.push({ ...zonerate.filter(f => f.rate === o)[0] })
      })
      return final
    },
    totalFee() {
      if (this.yezzaShippings.length > 0) {
        let price = this.yezzaShippings.reduce((sum, p) => {
          return sum + p.fee
        }, 0)
        return price
      }
      return 0
    },
    disabledPaynow() {
      if (this.creditBalance < this.totalFee) {
        return true
      } else if (this.hastPostcodeError) {
        return true
      }
      if (this.yezzaShippings.filter(f => !f.fulfilment).length > 0) {
        return true
      }
      if (this.yezzaShippings.filter(f => !f.fee).length > 0) {
        return true
      }
      if (this.yezzaShippings.filter(f => !f.weight).length > 0) {
        return true
      }
      if (this.selectShippingType === 'courier' && this.yezzaShippings.filter(f => !f.delivery_at).length > 0) {
        return true
      }
      return false
    },
    creditBalance() {
      return this.company.prepaid_credits
    },
    typeFormUrl() {
      return `https://yezzaio.typeform.com/to/t348E6bz#id=${this.company.id}`
    },
    typeFormRateUrl() {
      return `https://yezzaio.typeform.com/to/Xiks3TOn#id=${this.company.id}`
    },
    matching() {
      return this.groupedOngoingData['matching'] || null
    }
  },
  watch: {
    isFetchingRates: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.includes(true)) {
          this.isFetching = true
        } else {
          this.isFetching = false
        }
        // console.log(val)
      }
    },
    selectedFulfilment(val) {
      if (val) {
        this.showPreferredService = true
      } else {
        this.showPreferredService = false
      }
    },
    preferredService() {
      this.updatePreferredService()
    }
  },
  mounted() {
    this.isReady = true
    this.checkLeadsSelection()
  },
  beforeDestroy() {
    if (this.toOngoingDialogCountdown) {
      clearTimeout(this.toOngoingDialogCountdown)
    }
  },
  methods: {
    ...mapActions(['showMessage', 'updateCompany']),
    checkLeadsSelection() {
      this.isFetching = true
      if (this.leads[0].shipping.fulfilment_type === 'courier') {
        this.selectedShippingType = 'courier'
      } else {
        this.selectedShippingType = 'local-delivery'
      }
      if (this.leads.map(m => m.shipping.yezzashipping).includes(null)) {
        this.fetchRates()
        this.step = 1
      } else {
        this.proceedBulkShipping()
      }
    },
    proceedBulkShipping() {
      this.isFetching = true
      let data = {
        shippings: [...this.leads.map(m => m.shipping.id)]
      }
      if (this.selectedFulfilment) {
        data['service_id'] = this.selectedFulfilment.service_id
      }
      this.$axios
        .post('/shipping/yezzashipping/bulk', data)
        .then(resp => {
          this.yezzaShippings = resp.data
          if (this.yezzaShippings.map(m => m.fulfilment).includes(null) && !this.selectedFulfilment) {
            this.step = 1
            this.fetchRates()
          } else {
            this.step = 2
            this.isFetching = false
            this.isFetchingRates = [false, false]
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          this.yezzaShippingError = true
          this.isFetching = false
          this.isFetchingRates = [false, false]
        })
    },
    fetchRates() {
      this.isFetchingRates = [true, true]
      this.$axios
        .get(`/shipping/yezzashipping/settings/${this.company.slug}`)
        .then(resp => {
          if (resp.data.courier && resp.data.courier.enabled) {
            this.$axios
              .get(`/shipping/yezzashipping/settings/${this.company.slug}/courier`)
              .then(resp => {
                if (resp.data.available_shipping.filter(f => f.enabled).length > 0) {
                  resp.data.available_shipping.filter(f => f.enabled).forEach(o => {
                    this.rates.push(o)
                  })
                }
                if (resp.data.preferred && this.selectedShippingType === 'courier' && resp.data.available_shipping.filter(f => f.enabled && f.service_id === resp.data.preferred).length > 0) {
                  this.selectedFulfilment = resp.data.available_shipping.find(f => f.enabled && f.service_id === resp.data.preferred)
                  this.proceedBulkShipping()
                } else {
                  this.isFetchingRates.splice(0, 1, false)
                }
              })
              .catch(() => {
                this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
                this.isFetchingRates.splice(0, 1, false)
              })
          } else {
            this.isFetchingRates.splice(0, 1, false)
          }
          if (resp.data.local_delivery && resp.data.local_delivery.enabled) {
            this.$axios
              .get(`/shipping/yezzashipping/settings/${this.company.slug}/local_delivery`)
              .then(resp => {
                if (resp.data.available_shipping.filter(f => f.enabled).length > 0) {
                  resp.data.available_shipping.filter(f => f.enabled).forEach(o => {
                    this.rates.push(o)
                  })
                }
                if (resp.data.preferred && this.selectedShippingType === 'local-delivery' && resp.data.available_shipping.filter(f => f.enabled && f.service_id === resp.data.preferred).length > 0) {
                  this.selectedFulfilment = resp.data.available_shipping.find(f => f.enabled && f.service_id === resp.data.preferred)
                  this.proceedBulkShipping()
                } else {
                  this.isFetchingRates.splice(1, 1, false)
                }
              })
              .catch(() => {
                this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
                this.isFetchingRates.splice(1, 1, false)
              })
          } else {
            this.isFetchingRates.splice(1, 1, false)
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          this.isFetchingRates = [false, false]
        })
    },
    selectShippingType(type) {
      this.selectedShippingType = type
      this.step = 1
    },
    clickEditIndividualOrder(lead) {
      this.selectedOrder = lead
      this.ysIndex = this.yezzaShippings.map(m => m.shipping).indexOf(lead.yezzashipping.shipping)
      this.editIndividualOrderDialog = true
    },
    clickEditDateGroup(leads) {
      this.ysDateGroup = leads.map(m => m.yezzashipping)
      this.editDateGroupDialog = true
    },
    clickEditDateTimeGroup(leads) {
      this.ysDateTimeGroup = leads.map(m => m.yezzashipping)
      this.editDateTimeGroupDialog = true
    },
    clickEditErrorOrder(lead) {
      this.selectedOrder = lead
      this.ysIndex = this.yezzaShippings.map(m => m.shipping).indexOf(lead.yezzashipping.shipping)
      this.editErrorDialog = true
    },
    removeOrder(ysdata) {
      let leadsIdx = this.leads.map(m => m.shipping.id).indexOf(ysdata.shipping)
      let ysIdx = this.yezzaShippings.map(m => m.shipping).indexOf(ysdata.shipping)
      this.leads.splice(leadsIdx, 1)
      this.yezzaShippings.splice(ysIdx, 1)
      this.selectedOrder = null
      this.ysIndex = null
      if (this.yezzaShippings.length === 0) {
        this.closeDialog()
      }
    },
    updateEditGroup(data) {
      // console.log(data)
      if (Array.isArray(data)) {
        data.forEach(o => {
          // this.yezzaShippings[this.yezzaShippings.map(m => m.shipping).indexOf(o.shipping)] = { ...o }
          this.$set(this.yezzaShippings[this.yezzaShippings.map(m => m.shipping).indexOf(o.shipping)], 'delivery_at', o.delivery_at)
          this.$set(this.yezzaShippings[this.yezzaShippings.map(m => m.shipping).indexOf(o.shipping)], 'fulfilment', o.fulfilment)
          this.$set(this.yezzaShippings[this.yezzaShippings.map(m => m.shipping).indexOf(o.shipping)], 'fee', o.fee)
        })
      }
      this.ysDateGroup = null
      this.ysDateTimeGroup = null
    },
    retryArrange(failArranged) {
      let newLead = []
      failArranged.forEach(o => {
        if (this.leads.filter(f => f.shipping.id === o.shipping_id).length > 0) {
          let data = { ...this.leads.filter(f => f.shipping.id === o.shipping_id)[0] }
          if (o.ext_remark && o.ext_remark.includes('send_code')) {
            data['postcode_error'] = true
          } else if (o.ext_remark && o.ext_remark.includes('delivery')) {
            data['area_error'] = true
          }
          newLead.push(data)
        }
      })
      if (newLead.length > 0) {
        this.isFetching = true
        this.$store.commit('orders/replaceLeads', newLead)
        // this.leads = [...newLead]
        this.arrangedShipment = false
        this.selectedShippingType = null
        this.selectedFulfilment = null
        this.arrangedShippings = []
        this.failedArrangedShippings = []
        this.step = 0
        this.rates = []
        this.yezzaShippings = []
        this.checkLeadsSelection()
      }
    },
    payNow() {
      this.isLoading = true
      this.isFetching = true
      let data = {
        shipping_method: this.yezzaShippings[0].fulfilment.shipping_method,
        shippings: [...this.yezzaShippings.map(m => m.shipping)]
      }
      this.$axios
        .post('/shipping/yezzashipping/submit_order', data)
        .then(async resp => {
          this.arrangedShippings = resp.data.orders.filter(f => f.status !== 'error')
          this.failedArrangedShippings = resp.data.orders.filter(f => f.status === 'error')
          if (this.selectedShippingType === 'local-delivery') {
            this.$store.commit('riders/updateRefetchAllOrders', true)
            // Trigger rider status first for updating rider vuex store data
            await this.checkRidersStatus()
            this.toOngoingDialogCountdown = setTimeout(() => {
              this.toOngoingDialog()
            }, 5000)
            this.arrangingRider = true
            this.fetchCompany()
          } else {
            if (this.arrangedShippings.length > 0) {
              this.fetchCompany()
            }
            this.arrangedShipment = true
          }
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.detail) {
            this.showMessage(['error', e.response.data.detail])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
        })
        .finally(() => {
          this.isLoading = false
          this.isFetching = false
        })
    },
    updatePreferredService() {
      let prefship = null
      if (this.preferredService && this.selectedFulfilment && this.selectedFulfilment.service_id) {
        prefship = this.selectedFulfilment.service_id
      }
      if (this.selectedFulfilment && this.selectedFulfilment.shipping_type === 'courier') {
        this.$axios.post(`/shipping/yezzashipping/settings/${this.company.slug}/courier`, { preferred: prefship }).catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
      } else {
        this.$axios.post(`/shipping/yezzashipping/settings/${this.company.slug}/local_delivery`, { preferred: prefship }).catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
      }
    },
    displayArrangeOnDate(value) {
      const date = DateTime.fromFormat(value, 'yyyy-MM-dd hh:mm:ss')
      return `${date.toFormat('dd/MM/yyyy')} at ${date.toFormat('hh:mma')}`
    },
    handleUpdateAddress() {
      this.leads[this.leads.map(m => m.pid).indexOf(this.selectedOrder.pid)].postcode_error = false
      this.leads[this.leads.map(m => m.pid).indexOf(this.selectedOrder.pid)].area_error = false
      this.$axios
        .get(`/shipping/yezzashipping/${this.yezzaShippings[this.ysIndex].id}`)
        .then(resp => {
          this.yezzaShippings[this.ysIndex] = resp.data
        })
        .catch(() => {})
    },
    shareToWA(tracking_no, phone) {
      window.open(`https://api.whatsapp.com/send?text=${tracking_no}&phone=${phone}`)
    },
    copyTrackingNo() {
      this.showMessage(['success', this.$t('success_message.tracking_number_copied_clipboard')])
    },
    copyTrackingLink() {
      this.showMessage(['success', this.$t('success_message.tracking_link_copied_clipboard')])
    },
    shareTrackingLinkToWA(shipping_name, tracking_no, phone) {
      const message = `Hi, we have arranged your delivery with ${shipping_name}. You can track its real-time location here: ${encodeURIComponent(tracking_no)}. Download Zoo to get notifications: ${encodeURIComponent('http://onelink.to/hzsjsu')}`
      window.open(`https://api.whatsapp.com/send?text=${message}&phone=${phone}`)
    },
    clickDownloadAWB(link) {
      if (this.$isMobile) {
        window.open(link)
      } else {
        location.href = link
      }
    },
    clickOpenTracking(link) {
      this.trackingViewLink = link
      window.open(this.trackingViewLink, '_blank')
    },
    fetchCompany() {
      this.$axios
        .get(`/companies/${this.company.id}/`)
        .then(resp => {
          this.updateCompany(resp.data)
        })
        .catch(() => {})
    },
    closeDialog() {
      // this.$emit('updateYsId', this.yezzaShipping.id)
      this.showModal = false
    },
    checkRidersStatus() {
      const params = { company: this.company.id }
      return this.$axios
        .get('/shipping/yezzashipping/ongoing', { params })
        .then(resp => {
          this.$store.commit('riders/updateOngoingData', resp.data)
        })
        .catch(() => {})
    },
    closeAllDialogs() {
      this.$emit('closeDialog')
      this.showModal = false
    },
    toOngoingDialog() {
      this.$store.commit('riders/updateRefetchAllOrders', true)
      this.openOngoingDialog()
    },
    openOngoingDialog() {
      this.closeAllDialogs()
      this.$store.commit('riders/updateOpenOngoingDialog', true)
    },
    finishArranging() {
      this.$emit('refetchLead')
      this.showModal = false
    },
    getTomorrowDate() {
      const today = new Date()
      let tomorrow = new Date(today.setDate(today.getDate() + 1))
      const date = DateTime.fromISO(tomorrow.toISOString())
      return `${date.toFormat('yyyy-MM-dd')} 08:00:00`
    },
    getAsapDate() {
      const today = new Date()
      const date = DateTime.fromISO(today.toISOString())
      return `Today, ${date.toFormat('dd')} ${date.monthLong} (ASAP)`
    },
    downloadBulkAwb(arrangedShippings) {
      let ids = arrangedShippings.map(m => m.ys_id).toString()
      let exportDomain = process.env.VUE_APP_BASE_URL
      let link = `${exportDomain}/shipping/yezzashipping/download_awb?yezzashipping_ids=${ids}`
      if (this.$isMobile) {
        window.open(link)
      } else {
        location.href = link
      }
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "arranging_shipment": "Arranging shipment",
    "please_do_not_refresh": "Please do not refresh this page",
    "arrangements_successful": "arrangements successful",
    "of": "of",
    "air_waybills_generated": "air waybills generated",
    "download_all": "Download All",
    "copy_and_share_tracking": "Copy and share tracking links with your customers.",
    "tracking_data_not_ready": "Tracking data is not ready yet, please check it back later.",
    "unsuccessful_orders": "Unsuccessful orders",
    "retry_arrange": "RETRY ARRANGE",
    "invalid_postcode": "Invalid postcode",
    "out_of_delivery_service": "Out of delivery service area",
    "unexpected_internal_error": "Unexpected internal error",
    "finding_you_a_rider": "Finding you a rider",
    "hold_tight": "Hold tight. This might take a while.",
    "view_all_ongoing_orders": "view all ongoing orders",
    "bulk_arrange_shipment": "Bulk arrange shipment",
    "unable_to_complete_request": "Unable to complete your request. Please try again later",
    "select_fulfilment_method": "Select fulfilment method for this group of orders",
    "courier_examples": "Poslaju, DHL, Pgeon, J&T, SkyNet",
    "local_delivery_examples": "Lalamove, Grab, Borzo",
    "save_as_preferred_service": "Save as preferred service for this manual rate",
    "click_on_individual": "Click on individual orders to edit",
    "selected_delivery_unavailable": "Selected delivery unavailable",
    "having_issues": "Having issues?",
    "tell_us_about_it": "Tell us about it.",
    "this_is_not_multistop": "This is not a multi-stop arrangement. Each individual order will be assigned one rider upon payment.",
    "proceed_to_review": "Proceed to review"
  },
  "id": {
    "arranging_shipment": "Mengatur pengiriman",
    "please_do_not_refresh": "Tolong jangan segarkan halaman ini",
    "arrangements_successful": "pengaturan berhasil",
    "of" : "dari",
    "air_waybills_generated": "air waybills dibuat",
    "download_all": "Unduh Semua",
    "copy_and_share_tracking": "Salin dan bagikan tautan pelacakan dengan pelanggan kamu.",
    "tracking_data_not_ready": "Data pelacakan belum siap, silakan periksa kembali nanti.",
    "unsuccessful_orders": "Pesanan gagal",
    "retry_arrange": "COBA LAGI ATUR",
    "invalid_postcode": "Kode pos tidak valid",
    "out_of_delivery_service": "Di luar area layanan pengiriman",
    "unexpected_internal_error": "Kesalahan internal tak terduga",
    "finding_you_a_rider": "Menemukan pengendara untuk kamu",
    "hold_tight": "tunggu sebentar. Ini mungkin memakan waktu cukup lama.",
    "view_all_ongoing_orders": "lihat semua pesanan yang sedang berlangsung",
    "bulk_arrange_shipment": "Pengiriman massal mengatur",
    "unable_to_complete_request": "Tidak dapat menyelesaikan permintaan kamu. Silakan coba lagi nanti",
    "select_fulfilment_method": "Pilih metode pemenuhan untuk grup pesanan ini",
    "courier_examples": "Poslaju, DHL, Pgeon, J&T, SkyNet",
    "local_delivery_examples": "Lalamove, Grab, Borzo",
    "save_as_preferred_service": "Simpan sebagai layanan pilihan untuk tarif manual ini",
    "click_on_individual": "Klik pesanan individual untuk mengedit",
    "selected_delivery_unavailable": "Pengiriman yang dipilih tidak tersedia",
    "have_issues": "Mengalami masalah?",
    "tell_us_about_it": "Beri tahu kami tentang hal itu.",
    "this_is_not_multistop": "Ini bukan pengaturan multi-stop. Setiap pesanan individu akan diberikan satu pengendara setelah pembayaran.",
    "proceed_to_review": "Lanjutkan ke peninjauan"
  }
}
</i18n>